export function getCodeErrorMessage(code) {
    let errorMessage;
    switch (code) {
        case "account_already_exists":
            errorMessage = "la cuenta ya existe"
            break;
        case "api_key_expired":
            errorMessage = "la clave de la API expiró"
            break;
        case "authentication_required":
            errorMessage = "Autenticacion requerida"
            break;
        case "balance_insufficient":
            errorMessage = "saldo insuficiente"
            break;
        case "bank_account_declined":
            errorMessage = "cuenta bancaria rechazada"
            break;
        case "bank_account_exists":
            errorMessage = "cuenta bancaria"
            break;
        case "bank_account_unusable":
            errorMessage = "cuenta bancaria inutilizable"
            break;
        case "bank_account_unverified":
            errorMessage = "cuenta bancaria sin verificar"
            break;
        case "bank_account_verification_failed":
            errorMessage = "verificación de cuenta bancaria fallida"
            break;
        case "card_decline_rate_limit_exceeded":
            errorMessage = "límite de tasa de rechazo de tarjeta excedido"
            break;
        case "card_declined":
            errorMessage = "tarjeta rechazada"
            break;
        case "charge_already_captured":
            errorMessage = "carga ya capturada"
            break;
        case "charge_already_refunded":
            errorMessage = "cargo ya reembolsado"
            break;
        case "charge_disputed":
            errorMessage = "cargo disputado"
            break;
        case "charge_exceeds_source_limit":
            errorMessage = "la carga excede el límite de la fuente"
            break;
        case "charge_expired_for_capture":
            errorMessage = "cargo vencido por captura"
            break;
        case "charge_invalid_parameter":
            errorMessage = "parámetro inválido de carga"
            break;
        case "country_code_invalid":
            errorMessage = "código de país no válido"
            break;
        case "country_unsupported":
            errorMessage = "país no admitido"
            break;
        case "coupon_expired":
            errorMessage = "cupón caducado"
            break;
        case "customer_max_payment_methods":
            errorMessage = "métodos de pago máximo del cliente"
            break;
        case "customer_max_subscriptions":
            errorMessage = "suscripciones máximas del cliente"
            break;
        case "email_invalid":
            errorMessage = "correo electrónico inválido"
            break;
        case "expired_card":
            errorMessage = "tarjeta expirada"
            break;
        case "flinks_session_incomplete":
            errorMessage = "sesión de parpadeos incompleta"
            break;
        case "idempotency_key_in_use":
            errorMessage = "llave de idempotencia en uso"
            break;
        case "incorrect_address":
            errorMessage = "Direccion incorrecta"
            break;
        case "incorrect_cvc":
            errorMessage = "cvc incorrecto"
            break;
        case "incorrect_number":
            errorMessage = "numero incorrecto"
            break;
        case "instant_payouts_unsupported":
            errorMessage = "pagos instantáneos no admitidos"
            break;
        case "invalid_card_type":
            errorMessage = "tipo de tarjeta inválido"
            break;
        case "invalid_characters":
            errorMessage = "Caracteres inválidos"
            break;
        case "invalid_charge_amount":
            errorMessage = "importe de cargo no válido"
            break;
        case "invalid_cvc":
            errorMessage = "cvc inválido"
            break;
        case "invalid_expiry_month":
            errorMessage = "mes de vencimiento inválido"
            break;
        case "invalid_expiry_year":
            errorMessage = "año de vencimiento inválido"
            break;
        case "invalid_number":
            errorMessage = "número invalido"
            break;
        case "invalid_source_usage":
            errorMessage = "uso de fuente inválido"
            break;
        case "invoice_no_customer_line_items":
            errorMessage = "factura sin líneas de pedido del cliente"
            break;
        case "invoice_no_subscription_line_items":
            errorMessage = "factura sin líneas de pedido de suscripción"
            break;
        case "invoice_not_editable":
            errorMessage = "factura no editable"
            break;
        case "invoice_payment_intent_requires_action":
            errorMessage = "la intención de pago de la factura requiere acción"
            break;
        case "invoice_upcoming_none":
            errorMessage = "factura próxima ninguno"
            break;
        case "livemode_mismatch":
            errorMessage = "Livemode desajuste"
            break;
        case "lock_timeout":
            errorMessage = "tiempo de espera de bloqueo"
            break;
        case "missing":
            errorMessage = "desaparecido"
            break;
        case "not_allowed_on_standard_account":
            errorMessage = "no permitido en cuenta estándar"
            break;
        case "order_creation_failed":
            errorMessage = "la creación del pedido falló"
            break;
        case "order_required_settings":
            errorMessage = "ordenar configuraciones requeridas"
            break;
        case "order_status_invalid":
            errorMessage = "estado del pedido no válido"
            break;
        case "order_upstream_timeout":
            errorMessage = "ordenar tiempo de espera aguas arriba"
            break;
        case "out_of_inventory":
            errorMessage = "fuera de inventario"
            break;
        case "parameter_invalid_empty":
            errorMessage = "parámetro inválido vacío"
            break;
        case "parameter_invalid_integer":
            errorMessage = "parámetro entero no válido"
            break;
        case "parameter_invalid_string_blank":
            errorMessage = "parámetro cadena no válida en blanco"
            break;
        case "parameter_invalid_string_empty":
            errorMessage = "parámetro no válido cadena vacía"
            break;
        case "parameter_missing":
            errorMessage = "falta el parámetro"
            break;
        case "parameter_unknown":
            errorMessage = "parámetro desconocido"
            break;
        case "parameters_exclusive":
            errorMessage = "parámetros exclusivos"
            break;
        case "payment_intent_action_required":
            errorMessage = "acción de intención de pago requerida"
            break;
        case "payment_intent_authentication_failure":
            errorMessage = "error de autenticación de intención de pago"
            break;
        case "payment_intent_incompatible_payment_method":
            errorMessage = "intención de pago método de pago incompatible"
            break;
        case "payment_intent_invalid_parameter":
            errorMessage = "parámetro de intención de pago no válido"
            break;
        case "payment_intent_payment_attempt_failed":
            errorMessage = "intento de pago intento de pago fallido"
            break;
        case "payment_intent_unexpected_state":
            errorMessage = "intento de pago estado inesperado"
            break;
        case "payment_method_invalid_parameter":
            errorMessage = "parámetro de método de pago no válido"
            break;
        case "payment_method_unactivated":
            errorMessage = "método de pago desactivado"
            break;
        case "payment_method_unexpected_state":
            errorMessage = "método de pago estado inesperado"
            break;
        case "payouts_not_allowed":
            errorMessage = "pagos no permitidos"
            break;
        case "platform_api_key_expired":
            errorMessage = "la clave API de la plataforma expiró"
            break;
        case "postal_code_invalid":
            errorMessage = "Código postal inválido"
            break;
        case "processing_error":
            errorMessage = "Error de proceso"
            break;
        case "product_inactive":
            errorMessage = "Producto inactivo"
            break;
        case "rate_limit":
            errorMessage = "Límite de tarifa"
            break;
        case "resource_already_exists":
            errorMessage = "El producto ya existe"
            break;
        case "resource_missing":
            errorMessage = "Producto perdido"
            break;
        case "routing_number_invalid":
            errorMessage = "número de ruta no válido"
            break;
        case "secret_key_required":
            errorMessage = "clave secreta requerida"
            break;
        case "sepa_unsupported_account":
            errorMessage = "Sepa cuenta no compatible"
            break;
        case "setup_attempt_failed":
            errorMessage = "intento de configuración fallido"
            break;
        case "setup_intent_authentication_failure":
            errorMessage = "error de autenticación de intento de configuración"
            break;
        case "setup_intent_invalid_parameter":
            errorMessage = "parámetro de intento de configuración no válido"
            break;
        case "setup_intent_unexpected_state":
            errorMessage = "intento de configuración estado inesperado"
            break;
        case "shipping_calculation_failed":
            errorMessage = "cálculo de envío fallido"
            break;
        case "sku_inactive":
            errorMessage = "sku inactivo"
            break;
        case "state_unsupported":
            errorMessage = "estado no compatible"
            break;
        case "tax_id_invalid":
            errorMessage = "identificación fiscal no válida"
            break;
        case "taxes_calculation_failed":
            errorMessage = "cálculo de impuestos fallido"
            break;
        case "testmode_charges_only":
            errorMessage = "solo cargos de modo de prueba"
            break;
        case "tls_version_unsupported":
            errorMessage = "versión tls no compatible"
            break;
        case "token_already_used":
            errorMessage = "ficha ya utilizada"
            break;
        case "token_in_use":
            errorMessage = "ficha en uso"
            break;
        case "transfers_not_allowed":
            errorMessage = "transferencias no permitidas"
            break;
        case "upstream_order_creation_failed":
            errorMessage = "la creación del pedido aguas arriba falló"
            break;
        case "url_invalid":
            errorMessage = "url inválida"
            break;

        default:
            errorMessage = 'Error'
            break;
    }
    return errorMessage;
}








